module.exports = __webpack_public_path__ + "static/media/6.8da22fa2.jpg";